<template>
  <div class="p-fluid" style="direction: rtl">
    <div class="card  p-d-flex p-jc-center">
      <DataTable
          :rowClass="rowClass"
          :value="data"
          :selection.sync="selectedItems"
          :resizableColumns="false"
          @cell-edit-complete="onCellEditComplete"
          columnResizeMode="fit"
          dataKey="id"
          class="
          p-datatable-customers
          p-datatable-sm
          p-datatable-gridlines
          p-datatable-striped
        "
          stateStorage="local"
          stateKey="user-data-state"
          editMode="cell"
          :filters="filters"
          :loading="loading"
          sortField="grade.hebrewName"
          :sortOrder="1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 20, 50]"
          currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
      >
        <!-- header -->

        <template #header>
          <div class="p-p-2 table-header">
            <div class="p-m-1 p-d-inline-flex">
              <h1 style="text-align: center">סוגי נוכחות</h1>
            </div>

            <div class="p-d-flex">

              <Button
                  v-tooltip.top="'מחיקה'"
                  v-if="selectedItems.length > 0"
                  icon="pi pi-trash"
                  class="p-mr-2 p-button-danger"
                  @click="isDialogDelete = true"
              />
              <Button
                  v-tooltip.top="'הוספה'"
                  icon="pi pi-plus"
                  class="p-mr-2 p-button-success"
                  @click="isDialogAdd = true"
              />
            </div>
          </div>
        </template>
        <template #loading> טוען נתונים מהמערכת, אנא המתן... </template>
        <Column selectionMode="multiple" headerStyle="width: 3em"></Column>

        <!-- id -->

        <Column
            headerStyle="width: 20%;"
            bodyStyle="text-align: right; overflow: visible ; color: #757575;"
          field="id"
          header="ת.ז"
          sortable
        >
          <template #filter>
            <InputText
              type="text"
              v-model="filters['id']"
              class="p-column-filter"
              placeholder="חפש לפי ת.ז."
            />
          </template>
        </Column>

        <!-- v-for -->
        <Column
          headerStyle="text-align: rtl"
          bodyStyle="text-align: right; overflow: visible"
          sortable
          v-for="col of columns"
          :field="col.field"
          :header="col.header"
          :key="col.field"
        >
          <template #filter>
            <InputText
              type="text"
              v-model="filters[col.field]"
              class="p-column-filter"
              :placeholder="`חפש לפי ${col.header}`"
            />
          </template>
          <template #editor="slotProps">
            <InputText
              v-if="slotProps.column.field !== 'id'"
              :value="slotProps.data[slotProps.column.field]"
              @input="onCellEdit($event, slotProps)"
            />
            <div v-else>{{ slotProps.data[slotProps.column.field] }}</div>
          </template>
        </Column>
        <!-- v-for -->

        <!-- color -->

        <Column
            headerStyle="width: 20%;"
            bodyStyle="text-align: right; "
            field="color"
            header="צבע"
            sortable
        >
          <template #filter>
            <InputText
                type="text"
                v-model="filters['color']"
                class="p-column-filter"
                placeholder="חפש לפי צבע"
            />
          </template>
          <template #body="slotProps">
            <ColorPicker :value="slotProps.data.color"  />
          </template>
          <template #editor="slotProps">
            <ColorPicker :value="slotProps.data[color]"
                         @input="onCellEdit($event, slotProps)"/>
          </template>
        </Column>
          <Column
                  bodyStyle="text-align: right; overflow: visible"
                  sortable
                  sortField="type"
                  :field="'reportActive'"
                  :header="'לתעודה'"
                  :key="'id'"
                  filterMatchMode="in"
          >
              <template #editor="slotProps">
                  <checkbox v-model="slotProps.data.reportActive" :binary="true"></checkbox>


              </template>
              <template #body="slotProps">
                  <checkbox v-model="slotProps.data.reportActive" :binary="true"></checkbox>
                  <!--                  <div class="subject-tracking " :class="slotProps.data.type">-->
                  <!--                      {{ getTypeLabel(slotProps.data.type) }}-->
                  <!--                  </div>-->
              </template>
          </Column>
          <Column
                  bodyStyle="text-align: right; overflow: visible"
                  sortable
                  sortField="type"
                  :field="'active'"
                  :header="'פעיל'"
                  :key="'id'"
                  filterMatchMode="in"
          >
              <template #editor="slotProps">
                  <checkbox v-model="slotProps.data.active" :binary="true"></checkbox>
              </template>
              <template #body="slotProps">
                  <checkbox v-model="slotProps.data.active" :binary="true"></checkbox>
              </template>
          </Column>
          <Column
                  bodyStyle="text-align: right; overflow: visible"
                  sortable
                  sortField="type"
                  :field="'showStatics'"
                  :header="'הצג בדוח סיכום'"
                  :key="'id'"
                  filterMatchMode="in"
          >
              <template #editor="slotProps">
                  <checkbox v-model="slotProps.data.showStatics" :binary="true"></checkbox>
              </template>
              <template #body="slotProps">
                  <checkbox v-model="slotProps.data.showStatics" :binary="true"></checkbox>
              </template>
          </Column>

        <template #footer>
          סה״כ {{ data ? data.length : 0 }} רשומות.
        </template>
      </DataTable>
    </div>

    <add-dialog
      :show="isDialogAdd"
      v-on:addItem="addItem"
      v-on:closeDialog="isDialogAdd = false"
    >
    </add-dialog>
    <delete-dialog
      :title="'מחיקה'"
      :context="`האם תרצה להסיר  ${selectedItems.length}   רשומות מהמערכת?`"
      :show="isDialogDelete"
      v-on:choice="deleteItem"
    >
    </delete-dialog>
  </div>
</template>

<script>
import addDialog from "../../../dialogs/PresenceStatusDialog.vue";
import deleteDialog from "../../../dialogs/DeleteDialog.vue";
import Service from "../../../service/Service";
import Vue from "vue";

export default {
  service: null,
  components: {
    addDialog,
    deleteDialog,
  },
  created() {
    this.service = new Service();
  },
  mounted() {
    this.service.get(this.ENTITY).then((data) => {
      this.data = data;
      this.loading = false;
    });
  },
  data() {
    return {
      ENTITY: 'presence-status',
      data: null,
      loading: true,
      isDialogDelete: false,
      isDialogAdd: false,
      selectedItems: [],
      filters: {},
      itemBeforeEditing: {},
      itemAfterEditing: {},
      columns: [{ field: "hebrewName", header: "שם" }, { field: "sort", header: "סדר" }],
    };
  },
  methods: {
    rowClass(data) {
      return data.enabled === false ? "row-unenabled" : null;
    },

    addItem(item) {
      this.data.push(item);
    },

    deleteItem(choice) {
      this.isDialogDelete = false;
      if (choice) {
        const itemsIds = [];
        const selscteds = this.selectedItems;
        this.selectedItems.forEach((item) => {
          itemsIds.push(item.id);
        });

        this.service.deleteMany(itemsIds, this.ENTITY).then(() => {
          this.openNotification("success", `מעולה`, `המידע הוסר מהמערכת`);

          selscteds.forEach((selected) => {
            this.data = this.data.filter((item) => item.id !== selected.id);
          });
        });

        this.isDialogDelete = false;
      }
      this.selectedItems = [];
    },

    async onCellEditComplete(event) {
        let objToSend
        if ( this.itemAfterEditing?.id === undefined){
            objToSend = event.data
        } else {
            const index = this.data.findIndex(
                (item) => item.id === this.itemAfterEditing.id
            );
            Vue.set(this.data, index, this.itemAfterEditing);
            if (this.itemAfterEditing.color[0] !== '#') {

                this.itemAfterEditing.color = `#${this.itemAfterEditing.color}`
            }
            objToSend = this.itemAfterEditing
        }
        this.service
            .update(objToSend, this.ENTITY)

        .then(() => {})
        .catch(() => {
          Vue.set(this.data, index, this.itemBeforeEditing);
          this.openNotification(
            "danger",
            `אופס`,
            `קרתה תקלה בעדכון הנתונים במערכת`
          );
        });
    },

    onCellEdit(newValue, props) {
      this.itemBeforeEditing = { ...props.data };
      this.itemAfterEditing = { ...props.data };
      this.itemAfterEditing[props.column.field] = newValue;
    },
    openNotification(
        color,
        title,
        text,
        position = "right-left",
        duration = 3000
    ) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>


<style scoped>
/* ::v-deep(.editable-cells-table td.p-cell-editing) {
  padding-top: 0;
  padding-bottom: 0;
} */

.p-multiselect-label:not(.p-placeholder) {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.country-item-value {
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: 0.5rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.app-container {
  text-align: center;
}
.p-paginator {
  direction: rtl;
}

.p-paginator-icon {
  transform: scaleX(-1);
}

td {
  text-align: right !important;
}

p {
  text-align: right !important;
}

h4 {
  text-align: right !important;
}

::v-deep .row-unenabled {
  color: rgba(0, 0, 0, 0.3) !important;
}

th {
  text-align: right !important;
}
</style>